import LayoutV2 from "containers/LayoutV2";
import SearchForm from "./SearchForm";
import PhanTrang from "components/CommonComponent/PhanTrang";
import DanhSachTatToanTable from "./DanhSachTatToanTable";
import React, { useEffect, useState, useCallback } from "react";
import UserApi from "service/userApi";
import { formatDayMonth } from "utils/formatDate";
import DanhSachTatToanApi from "service/BaoCao/DanhSachTatToanApi";
import { pushNotification } from "utils/notifications";
import XuatExcelTatToan from "./ChucNang/XuatExcelTatToan";
import CauHinhApi from "service/cauHinhApi";
import "./deleteLoading.css";

const DanhSachTatToan = () => {
  const [listUserName, setListUserName] = useState([]);

  const [hasPermission, setHasPermission] = useState(null);
  const [RoleInDanhSachPhieu, setRoleInDanhSachPhieu] = useState(false);
  const [RoleInPhieu, setRoleInPhieu] = useState(false);
  const [RoleDaDoc, setRoleDaDoc] = useState(false);
  const [RoleXoaHopDongTheoCauHinh, setRoleXoaHopDongTheoCauHinh] =
    useState(false);

  //Data table
  const [ListData, setListData] = useState([]);
  const [Total, setTotal] = useState(0);
  const [TotalSoTienVay, setTotalSoTienVay] = useState(0);
  const [TotalChenhLech, setTotalChenhLech] = useState(0);
  const [TotalSoTienPhaiTatToan, setTotalSoTienPhaiTatToan] = useState(0);
  const [TotalSoTienDaTatToan, setTotalSoTienDaTatToan] = useState(0);

  //Data in danh sách
  const [ListFull, setListFull] = useState([]);
  const [TotalSoTienVay1, setTotalSoTienVay1] = useState(0);
  const [TotalChenhLech1, setTotalChenhLech1] = useState(0);
  const [TotalSoTienPhaiTatToan1, setTotalSoTienPhaiTatToan1] = useState(0);
  const [TotalSoTienDaTatToan1, setTotalSoTienDaTatToan1] = useState(0);

  const [Loading, setLoading] = useState(true);
  const [IsDeleting, setIsDeleting] = useState(false);
  // Giữ lại số dòng lúc bấm xóa vì selectedIds bị clear giữa chừng
  const [deletingCount, setDeletingCount] = useState(0);
  const [ShowXuatExcel, setShowXuatExcel] = useState(false);
  const [IsPrint, setIsPrint] = useState(null);

  const [selectedIds, setSelectedIds] = useState([]);
  const handleCheckDelete = (item, checked) => {
    setSelectedIds((prev) =>
      checked
        ? [...prev, item.ThuChiID]
        : prev.filter((id) => id !== item.ThuChiID)
    );
  };

  const handleCheckAll = (checked) => {
    if (checked) {
      const allIds = ListData.map((x) => x.ThuChiID);
      setSelectedIds(allIds);
    } else {
      setSelectedIds([]);
    }
  };

  const fetchPermission = async () => {
    try {
      DanhSachTatToanApi.phanQuyen().then((res) => {
        if (res.status === 200 && res.data) {
          setRoleInDanhSachPhieu(res.data.danhsachtattoan_indanhsachphieu);
          setRoleInPhieu(res.data.danhsachtattoan_inphieu);
          setRoleDaDoc(res.data.danhsachtattoan_dadoc);
          setRoleXoaHopDongTheoCauHinh(
            res.data.danhsachtattoan_xoahopdongtheocauhinh
          );
          setHasPermission(res.data.danhsachtattoan);
        }
      });
    } catch (err) {
      console.error("Lỗi load quyền:", err);
      setHasPermission(false);
    }
  };

  //Load list username để thêm vào dropdown SearchForm
  const loadDanhSachUserName = useCallback(async () => {
    try {
      const res = await UserApi.getAllUserName();
      setListUserName(res.data || []);
    } catch (error) {
      console.error("Lỗi load danh sách user name:", error);
    }
  }, []);

  // Params search
  const [dataSearch, setDataSearch] = useState({
    SearchText: "",
    DateFrom: null,
    DateTo: null,
    sUsername: "",
    TypeChoVay: "",
    Operator: "",
    SoTien: "",
    pageIndex: 1,
    pageSize: 25,
  });

  //Load data theo Params search
  const LoadDanhSachTatToan = useCallback(async (searchData, page) => {
    try {
      setLoading(true);
      const payload = {
        ...searchData,
        DateFrom: searchData.DateFrom
          ? formatDayMonth(searchData.DateFrom)
          : undefined,
        DateTo: searchData.DateTo
          ? formatDayMonth(searchData.DateTo)
          : undefined,
        pageIndex: page,
      };
      const res = await DanhSachTatToanApi.getDataTable(payload);
      if (res.status === 200) {
        const data = res.data || [];
        setSelectedIds([]);
        setListData(data.List || []);
        setTotal(data.ListTotal[0].TotalRow || 0);
        setTotalChenhLech(data.ListTotal[0].ChenhLech || 0);
        setTotalSoTienDaTatToan(data.ListTotal[0].TongTien || 0);
        setTotalSoTienPhaiTatToan(data.ListTotal[0].TienPhaiTatToan || 0);
        setTotalSoTienVay(data.ListTotal[0].Sotienvay || 0);
        setDataSearch((prev) => ({ ...prev, pageIndex: page }));
      } else {
        console.error("Lỗi khi load danh sách tất toán: ", res.message);
      }
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } catch (error) {
      console.error("Lỗi khi gọi Api danh sách tất toán:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    document.title = "Danh sách tất toán | Phần mềm quản lý cầm đồ Morman";
    fetchPermission();
    loadDanhSachUserName();
  }, []);

  useEffect(() => {
    if (hasPermission) {
      CauHinhApi.getConfigSys1().then((response) => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            const suDungCauHinhTatToan = response.data.find(
              (e) => e.keyConfig.toUpperCase() === "HETHONGSUDUNGCAUHINHTATTOAN"
            );
            const cauHinhTatToan = response.data.find(
              (e) => e.keyConfig.toUpperCase() === "CAUHINHTATTOAN"
            );
            const CauHinhTatToan_ThucHien = response.data.find(
              (e) => e.keyConfig.toUpperCase() === "CAUHINHTATTOAN_THUCHIEN"
            );
            if (
              RoleXoaHopDongTheoCauHinh &&
              CauHinhTatToan_ThucHien &&
              CauHinhTatToan_ThucHien.valueConfig === "tattoan_thucong" &&
              suDungCauHinhTatToan &&
              suDungCauHinhTatToan.valueConfig === "1" &&
              cauHinhTatToan &&
              cauHinhTatToan.valueConfig === "1"
            ) {
              setRoleXoaHopDongTheoCauHinh(true);
            } else {
              setRoleXoaHopDongTheoCauHinh(false);
            }
          }
        }
      });
      LoadDanhSachTatToan(dataSearch, 1);
    }
  }, [hasPermission]);

  const onChangeData = (field) => (event) => {
    const value = event?.target?.value ?? "";
    setDataSearch((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const onChangeDate = (field) => (value) => {
    setDataSearch((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handlePageChange = (pageNumber) => {
    LoadDanhSachTatToan(dataSearch, pageNumber);
  };

  const handlePageSizeChange = (pageSize) => {
    const data = { ...dataSearch, pageSize, pageIndex: 1 };
    setDataSearch(data);
    LoadDanhSachTatToan(data, 1);
  };

  const onSearch = () => {
    LoadDanhSachTatToan(dataSearch, 1);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      LoadDanhSachTatToan(dataSearch, 1);
    }
  };
  const handleChangeIsReaded = async (item, checked) => {
    try {
      setListData((prev) =>
        prev.map((x) =>
          x.ThuChiID === item.ThuChiID ? { ...x, IsReaded: checked } : x
        )
      );

      // Gọi API cập nhật trạng thái
      const res = await DanhSachTatToanApi.ChangeIsReaded({
        ThuChiID: item.ThuChiID,
        IsReaded: !!checked,
      });

      if (res || res?.status === 200) {
        pushNotification("Đã cập nhật ", "success", "TOP_CENTER", 1000);
      }
    } catch (err) {
      console.error("Lỗi khi cập nhật trạng thái Đã đọc:", err);
      pushNotification(
        "Có lỗi khi cập nhật trạng thái! " + err,
        "error",
        "TOP_CENTER",
        1000
      );
    }
  };
  //Load data in danh sách theo Params search
  const LoadDataInDanhSachTatToan = useCallback(async (searchData) => {
    try {
      const payload = {
        SearchText: searchData.SearchText,
        DateFrom: searchData.DateFrom
          ? formatDayMonth(searchData.DateFrom)
          : undefined,
        DateTo: searchData.DateTo
          ? formatDayMonth(searchData.DateTo)
          : undefined,
        sUsername: searchData.sUsername,
        TypeChoVay: searchData.TypeChoVay,
        Operator: searchData.Operator,
        SoTien: searchData.SoTien,
      };
      const res = await DanhSachTatToanApi.getDataInDanhSach(payload);
      if (res.status === 200) {
        const data = res.data || [];
        return data;
      } else {
        console.error(
          "Lỗi khi load dữ liệu in danh sách tất toán: ",
          res.message
        );
        return [];
      }
    } catch (error) {
      console.error(
        "Lỗi khi gọi Api lấy dữ liệu in danh sách tất toán:",
        error
      );
    }
  }, []);

  const btnXuatExcelClick = async () => {
    const data = await LoadDataInDanhSachTatToan(dataSearch);
    if (data.ListFull && data.ListFull.length > 0) {
      setListFull(data.ListFull || []);
      setTotalChenhLech1(data.ListTotal[0].ChenhLech || 0);
      setTotalSoTienDaTatToan1(data.ListTotal[0].TongTien || 0);
      setTotalSoTienPhaiTatToan1(data.ListTotal[0].TienPhaiTatToan || 0);
      setTotalSoTienVay1(data.ListTotal[0].Sotienvay || 0);
      setIsPrint(false);
      setShowXuatExcel(true);
    } else {
      pushNotification(
        "Không có dữ liệu xuất excel!",
        "error",
        "TOP_CENTER",
        1000
      );
    }
  };

  const btnInDanhSachClick = async () => {
    const data = await LoadDataInDanhSachTatToan(dataSearch);
    if (data.ListFull && data.ListFull.length > 0) {
      setListFull(data.ListFull || []);
      setTotalChenhLech1(data.ListTotal[0].ChenhLech || 0);
      setTotalSoTienDaTatToan1(data.ListTotal[0].TongTien || 0);
      setTotalSoTienPhaiTatToan1(data.ListTotal[0].TienPhaiTatToan || 0);
      setTotalSoTienVay1(data.ListTotal[0].Sotienvay || 0);
      setIsPrint(true);
      setShowXuatExcel(true);
    } else {
      pushNotification("Không có dữ liệu in!", "error", "TOP_CENTER", 1000);
    }
  };

  const handleDelete = async () => {
    if (selectedIds.length === 0) {
      pushNotification("Chưa chọn dòng nào để xóa", "warning");
      return;
    }

    if (!window.confirm("Bạn có chắc chắn muốn xóa các dòng đã chọn?")) {
      return;
    }

    try {
      setDeletingCount(selectedIds.length);
      setIsDeleting(true);
      const res = await DanhSachTatToanApi.DeleteTatToan({
        danhSach: selectedIds,
      });

      if (res?.status === 200) {
        pushNotification("Xóa thành công", "success");

        // clear checkbox
        setSelectedIds([]);

        // reload list - chờ load xong mới tắt popup loading
        await LoadDanhSachTatToan(dataSearch, dataSearch.pageIndex);
      }
    } catch (err) {
      console.error("Lỗi khi xóa:", err);
      pushNotification("Xóa thất bại", "error");
    } finally {
      setIsDeleting(false);
    }
  };

  const ModelClose = () => {
    setIsPrint(null);
    setShowXuatExcel(false);
    setListFull([]);
    setTotalChenhLech1(0);
    setTotalSoTienDaTatToan1(0);
    setTotalSoTienPhaiTatToan1(0);
    setTotalSoTienVay1(0);
  };

  if (hasPermission === false) {
    return (
      <LayoutV2>
        <h2 className="text-danger">
          <div className="custom-table-row">
            <div
              className="custom-table-cell text-center red"
              style={{ width: "100%" }}
            >
              Bạn không có quyền truy cập trang này!
            </div>
          </div>
        </h2>
      </LayoutV2>
    );
  }
  return (
    <>
      <LayoutV2>
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div className="row header">
                          <img
                            src="/app-assets/images/icon-hop-dong-cho-duyet.png"
                            alt="logo"
                          />
                          <h1 className="text-info-home">Danh sách tất toán</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="card border-light mb-3 show-table-main card-v2"
                  style={{}}
                >
                  <div className="card-body card-body-v2">
                    <SearchForm
                      listUserName={listUserName}
                      dataSearch={dataSearch}
                      onChangeData={onChangeData}
                      onChangeDate={onChangeDate}
                      onSearch={onSearch}
                      handleKeyDown={handleKeyDown}
                    />
                    <div
                      className="search-new"
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "15px",
                        paddingRight: "25px",
                        gap: "15px",
                        color: "#00B69B",
                        fontWeight: "bold",
                      }}
                    >
                      {RoleInDanhSachPhieu && (
                        <>
                          <a
                            className="iconTableMorman"
                            title="In danh sách"
                            onClick={() => btnInDanhSachClick()}
                          >
                            <i class="la la-print"></i>
                          </a>
                          <a
                            className="iconTableMorman"
                            title="Xuất excel"
                            onClick={() => btnXuatExcelClick()}
                          >
                            <i class="la la-level-up"></i>
                          </a>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                {Loading && (
                  <>
                    <div className="loader loader-default is-active"></div>
                  </>
                )}
                {!Loading && (
                  <>
                    <div
                      className="card border-light mb-3 card-v2"
                      style={{ marginTop: "-35px" }}
                    >
                      {RoleXoaHopDongTheoCauHinh && (
                        // <button
                        //   className="btn btn-danger"
                        //   disabled={selectedIds.length === 0}
                        //   onClick={handleDelete}
                        // >
                        //   Xóa ({selectedIds.length})
                        // </button>
                        <div>
                          <button
                            type="button"
                            className="btn btn-border-red"
                            onClick={handleDelete}
                            disabled={IsDeleting}
                            style={{
                              margin: "10px",
                            }}
                          >
                            Xóa ({selectedIds.length})
                          </button>
                        </div>
                      )}
                      <div
                        className="card-body card-body-v2"
                        style={{ userSelect: "text" }}
                      >
                        <DanhSachTatToanTable
                          listUserName={listUserName}
                          list={ListData}
                          pageIndex={dataSearch.pageIndex}
                          pageSize={dataSearch.pageSize}
                          Total={Total}
                          TotalSoTienVay={TotalSoTienVay}
                          TotalSoTienPhaiTatToan={TotalSoTienPhaiTatToan}
                          TotalSoTienDaTatToan={TotalSoTienDaTatToan}
                          TotalChenhLech={TotalChenhLech}
                          RoleDaDoc={RoleDaDoc}
                          RoleXoaHopDongTheoCauHinh={RoleXoaHopDongTheoCauHinh}
                          RoleInPhieu={RoleInPhieu}
                          handleChangeIsReaded={handleChangeIsReaded}
                          handleCheckDelete={handleCheckDelete}
                          handleCheckAll={handleCheckAll}
                          selectedIds={selectedIds}
                        />
                      </div>
                      <div
                        className="card border-light mb-3 card-v2"
                        style={{
                          marginLeft: "15px",
                          marginRight: "15px",
                          marginTop: "15px",
                        }}
                      >
                        <div
                          className="card-body card-body-v2"
                          style={{ display: Total === 0 ? "none" : "block" }}
                        >
                          <PhanTrang
                            pageIndex={dataSearch.pageIndex}
                            pageSize={dataSearch.pageSize}
                            totalCount={Total}
                            onPageChange={handlePageChange}
                            onPageSizeChange={handlePageSizeChange}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </LayoutV2>
      {ShowXuatExcel && (
        <XuatExcelTatToan
          show={ShowXuatExcel}
          onHide={ModelClose}
          listData={ListFull}
          totals={{
            TotalChenhLech: TotalChenhLech1,
            TotalSoTienDaTatToan: TotalSoTienDaTatToan1,
            TotalSoTienPhaiTatToan: TotalSoTienPhaiTatToan1,
            TotalSoTienVay: TotalSoTienVay1,
          }}
          isPrint={IsPrint}
        />
      )}
      {IsDeleting && (
        <div className="dstt-del-overlay">
          <div className="dstt-del-card">
            <div className="dstt-del-icon">
              <i className="fas fa-trash"></i>
            </div>
            <p className="dstt-del-title">Đang xóa dữ liệu</p>
            <p className="dstt-del-desc">
              {deletingCount > 0
                ? `Đang xử lý ${deletingCount} dòng đã chọn`
                : "Vui lòng chờ trong giây lát"}
            </p>
            <div className="dstt-del-track">
              <div className="dstt-del-bar"></div>
            </div>
            <p className="dstt-del-hint">Vui lòng không đóng trình duyệt</p>
          </div>
        </div>
      )}
    </>
  );
};
export default DanhSachTatToan;
